import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'

import type { Option } from '@segment/matcha/components/Menu/useMenu'

import type { FiltersState, Filter } from '@segment/api/types/common'

export const useFilters = (
  entries: [
    string,
    {
      title: string
      items: Filter[]
    }
  ][]
) => {
  const [filtersState, setFiltersState] = useState<FiltersState>({
    ...entries.reduce((acc, [key]) => ({ ...acc, [key]: [] }), {}),
  })

  const createHandler = (key: string, setState: Dispatch<SetStateAction<FiltersState>>) => (selected: Option[]) =>
    setState((prev) => ({ ...prev, [key]: selected }))

  const selectHandlers: any = entries.reduce(
    (acc, [key]) => ({ ...acc, [key]: createHandler(key, setFiltersState) }),
    {}
  )

  return {
    filtersState,
    selectHandlers,
  }
}
